type Props = {
  value: string;
  onChange: (date: string) => void;
};

const MIN_DATE = '1900-01-01';

/**
 * 웹 생년월일 입력 — 모바일 브라우저 네이티브 date 피커를 띄운다.
 * (webview AblyDatePicker 대응; RN-Web은 ui-kit 날짜 피커가 없어 DOM date input 사용)
 */
export const BirthdaySelector = ({ value, onChange }: Props) => {
  // 로컬 기준 오늘(YYYY-MM-DD). toISOString은 UTC라 KST 새벽에 하루 어긋난다.
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

  return (
    <input
      type={'date'}
      value={value}
      min={MIN_DATE}
      max={today}
      onChange={event => onChange(event.target.value)}
      style={{
        height: 48,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#E5E7EB',
        borderRadius: 8,
        padding: '0 12px',
        fontSize: 15,
        color: '#22242B',
        width: '100%',
        boxSizing: 'border-box',
      }}
    />
  );
};
